export enum LockStatusFilterEnum {
  Unlocked = "1",
  New = "2",
  Manual = "4",
  Locked = "6",
  All = "7"
}
